module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-movie-18-years.4c534195.svg";